// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
	--tw-border-spacing-x: 0;
	--tw-border-spacing-y: 0;
	--tw-translate-x: 0;
	--tw-translate-y: 0;
	--tw-rotate: 0;
	--tw-skew-x: 0;
	--tw-skew-y: 0;
	--tw-scale-x: 1;
	--tw-scale-y: 1;
	--tw-pan-x:  ;
	--tw-pan-y:  ;
	--tw-pinch-zoom:  ;
	--tw-scroll-snap-strictness: proximity;
	--tw-gradient-from-position:  ;
	--tw-gradient-via-position:  ;
	--tw-gradient-to-position:  ;
	--tw-ordinal:  ;
	--tw-slashed-zero:  ;
	--tw-numeric-figure:  ;
	--tw-numeric-spacing:  ;
	--tw-numeric-fraction:  ;
	--tw-ring-inset:  ;
	--tw-ring-offset-width: 0px;
	--tw-ring-offset-color: #fff;
	--tw-ring-color: rgb(59 130 246 / 0.5);
	--tw-ring-offset-shadow: 0 0 #0000;
	--tw-ring-shadow: 0 0 #0000;
	--tw-shadow: 0 0 #0000;
	--tw-shadow-colored: 0 0 #0000;
	--tw-blur:  ;
	--tw-brightness:  ;
	--tw-contrast:  ;
	--tw-grayscale:  ;
	--tw-hue-rotate:  ;
	--tw-invert:  ;
	--tw-saturate:  ;
	--tw-sepia:  ;
	--tw-drop-shadow:  ;
	--tw-backdrop-blur:  ;
	--tw-backdrop-brightness:  ;
	--tw-backdrop-contrast:  ;
	--tw-backdrop-grayscale:  ;
	--tw-backdrop-hue-rotate:  ;
	--tw-backdrop-invert:  ;
	--tw-backdrop-opacity:  ;
	--tw-backdrop-saturate:  ;
	--tw-backdrop-sepia:  ;
	--tw-contain-size:  ;
	--tw-contain-layout:  ;
	--tw-contain-paint:  ;
	--tw-contain-style:  ;
}
::backdrop {
	--tw-border-spacing-x: 0;
	--tw-border-spacing-y: 0;
	--tw-translate-x: 0;
	--tw-translate-y: 0;
	--tw-rotate: 0;
	--tw-skew-x: 0;
	--tw-skew-y: 0;
	--tw-scale-x: 1;
	--tw-scale-y: 1;
	--tw-pan-x:  ;
	--tw-pan-y:  ;
	--tw-pinch-zoom:  ;
	--tw-scroll-snap-strictness: proximity;
	--tw-gradient-from-position:  ;
	--tw-gradient-via-position:  ;
	--tw-gradient-to-position:  ;
	--tw-ordinal:  ;
	--tw-slashed-zero:  ;
	--tw-numeric-figure:  ;
	--tw-numeric-spacing:  ;
	--tw-numeric-fraction:  ;
	--tw-ring-inset:  ;
	--tw-ring-offset-width: 0px;
	--tw-ring-offset-color: #fff;
	--tw-ring-color: rgb(59 130 246 / 0.5);
	--tw-ring-offset-shadow: 0 0 #0000;
	--tw-ring-shadow: 0 0 #0000;
	--tw-shadow: 0 0 #0000;
	--tw-shadow-colored: 0 0 #0000;
	--tw-blur:  ;
	--tw-brightness:  ;
	--tw-contrast:  ;
	--tw-grayscale:  ;
	--tw-hue-rotate:  ;
	--tw-invert:  ;
	--tw-saturate:  ;
	--tw-sepia:  ;
	--tw-drop-shadow:  ;
	--tw-backdrop-blur:  ;
	--tw-backdrop-brightness:  ;
	--tw-backdrop-contrast:  ;
	--tw-backdrop-grayscale:  ;
	--tw-backdrop-hue-rotate:  ;
	--tw-backdrop-invert:  ;
	--tw-backdrop-opacity:  ;
	--tw-backdrop-saturate:  ;
	--tw-backdrop-sepia:  ;
	--tw-contain-size:  ;
	--tw-contain-layout:  ;
	--tw-contain-paint:  ;
	--tw-contain-style:  ;
}
.\\!visible {
	visibility: visible !important;
}
.visible {
	visibility: visible;
}
.fixed {
	position: fixed;
}
.absolute {
	position: absolute;
}
.relative {
	position: relative;
}
.sticky {
	position: sticky;
}
.bottom-5 {
	bottom: 1.25rem;
}
.left-0 {
	left: 0px;
}
.top-0 {
	top: 0px;
}
.z-10 {
	z-index: 10;
}
.col-span-1 {
	grid-column: span 1 / span 1;
}
.col-span-2 {
	grid-column: span 2 / span 2;
}
.col-span-3 {
	grid-column: span 3 / span 3;
}
.col-span-4 {
	grid-column: span 4 / span 4;
}
.col-span-5 {
	grid-column: span 5 / span 5;
}
.col-start-1 {
	grid-column-start: 1;
}
.m-5 {
	margin: 1.25rem;
}
.m-8 {
	margin: 2rem;
}
.m-auto {
	margin: auto;
}
.-mx-10 {
	margin-left: -2.5rem;
	margin-right: -2.5rem;
}
.mx-10 {
	margin-left: 2.5rem;
	margin-right: 2.5rem;
}
.mx-2 {
	margin-left: 0.5rem;
	margin-right: 0.5rem;
}
.mx-auto {
	margin-left: auto;
	margin-right: auto;
}
.my-2 {
	margin-top: 0.5rem;
	margin-bottom: 0.5rem;
}
.my-4 {
	margin-top: 1rem;
	margin-bottom: 1rem;
}
.my-6 {
	margin-top: 1.5rem;
	margin-bottom: 1.5rem;
}
.mb-2 {
	margin-bottom: 0.5rem;
}
.mb-4 {
	margin-bottom: 1rem;
}
.ml-2 {
	margin-left: 0.5rem;
}
.ml-6 {
	margin-left: 1.5rem;
}
.mr-2 {
	margin-right: 0.5rem;
}
.mt-10 {
	margin-top: 2.5rem;
}
.mt-2 {
	margin-top: 0.5rem;
}
.mt-4 {
	margin-top: 1rem;
}
.mt-48 {
	margin-top: 12rem;
}
.mt-5 {
	margin-top: 1.25rem;
}
.mt-6 {
	margin-top: 1.5rem;
}
.line-clamp-1 {
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
}
.line-clamp-4 {
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 4;
}
.line-clamp-none {
	overflow: visible;
	display: block;
	-webkit-box-orient: horizontal;
	-webkit-line-clamp: none;
}
.block {
	display: block;
}
.inline-block {
	display: inline-block;
}
.inline {
	display: inline;
}
.flex {
	display: flex;
}
.table {
	display: table;
}
.grid {
	display: grid;
}
.hidden {
	display: none;
}
.h-10 {
	height: 2.5rem;
}
.h-12 {
	height: 3rem;
}
.h-44 {
	height: 11rem;
}
.h-52 {
	height: 13rem;
}
.h-64 {
	height: 16rem;
}
.h-\\[40px\\] {
	height: 40px;
}
.h-\\[72px\\] {
	height: 72px;
}
.h-screen {
	height: 100vh;
}
.min-h-screen {
	min-height: 100vh;
}
.w-1\\/2 {
	width: 50%;
}
.w-10 {
	width: 2.5rem;
}
.w-11\\/12 {
	width: 91.666667%;
}
.w-12 {
	width: 3rem;
}
.w-14 {
	width: 3.5rem;
}
.w-16 {
	width: 4rem;
}
.w-2 {
	width: 0.5rem;
}
.w-2\\/3 {
	width: 66.666667%;
}
.w-2\\/5 {
	width: 40%;
}
.w-20 {
	width: 5rem;
}
.w-24 {
	width: 6rem;
}
.w-32 {
	width: 8rem;
}
.w-36 {
	width: 9rem;
}
.w-40 {
	width: 10rem;
}
.w-48 {
	width: 12rem;
}
.w-52 {
	width: 13rem;
}
.w-56 {
	width: 14rem;
}
.w-64 {
	width: 16rem;
}
.w-72 {
	width: 18rem;
}
.w-80 {
	width: 20rem;
}
.w-\\[230px\\] {
	width: 230px;
}
.w-\\[70px\\] {
	width: 70px;
}
.w-full {
	width: 100%;
}
.min-w-max {
	min-width: max-content;
}
.flex-shrink-0 {
	flex-shrink: 0;
}
.shrink-0 {
	flex-shrink: 0;
}
.flex-grow-0 {
	flex-grow: 0;
}
.transform {
	transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-default {
	cursor: default;
}
.cursor-not-allowed {
	cursor: not-allowed;
}
.cursor-pointer {
	cursor: pointer;
}
.grid-flow-col {
	grid-auto-flow: column;
}
.grid-cols-1 {
	grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
	grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
	grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
	grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
	grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
	grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7 {
	grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row-reverse {
	flex-direction: row-reverse;
}
.flex-col {
	flex-direction: column;
}
.flex-wrap {
	flex-wrap: wrap;
}
.place-content-stretch {
	place-content: stretch;
}
.place-items-center {
	place-items: center;
}
.items-end {
	align-items: flex-end;
}
.items-center {
	align-items: center;
}
.items-baseline {
	align-items: baseline;
}
.justify-start {
	justify-content: flex-start;
}
.justify-end {
	justify-content: flex-end;
}
.justify-center {
	justify-content: center;
}
.justify-between {
	justify-content: space-between;
}
.gap-1 {
	gap: 0.25rem;
}
.gap-10 {
	gap: 2.5rem;
}
.gap-2 {
	gap: 0.5rem;
}
.gap-20 {
	gap: 5rem;
}
.gap-3 {
	gap: 0.75rem;
}
.gap-4 {
	gap: 1rem;
}
.gap-5 {
	gap: 1.25rem;
}
.gap-6 {
	gap: 1.5rem;
}
.gap-7 {
	gap: 1.75rem;
}
.gap-8 {
	gap: 2rem;
}
.-space-x-4 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(-1rem * var(--tw-space-x-reverse));
	margin-left: calc(-1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(0.25rem * var(--tw-space-x-reverse));
	margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-10 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(2.5rem * var(--tw-space-x-reverse));
	margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(0.5rem * var(--tw-space-x-reverse));
	margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(0.75rem * var(--tw-space-x-reverse));
	margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(1rem * var(--tw-space-x-reverse));
	margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-5 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(1.25rem * var(--tw-space-x-reverse));
	margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(1.5rem * var(--tw-space-x-reverse));
	margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-x-reverse: 0;
	margin-right: calc(2rem * var(--tw-space-x-reverse));
	margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-20 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(5rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
	--tw-space-y-reverse: 0;
	margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
	margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.overflow-auto {
	overflow: auto;
}
.overflow-hidden {
	overflow: hidden;
}
.truncate {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.text-ellipsis {
	text-overflow: ellipsis;
}
.rounded {
	border-radius: 0.25rem;
}
.rounded-lg {
	border-radius: 0.5rem;
}
.rounded-md {
	border-radius: 0.375rem;
}
.rounded-sm {
	border-radius: 0.125rem;
}
.rounded-xl {
	border-radius: 0.75rem;
}
.border {
	border-width: 1px;
}
.border-0 {
	border-width: 0px;
}
.border-\\[1px\\] {
	border-width: 1px;
}
.border-b-0 {
	border-bottom-width: 0px;
}
.border-b-2 {
	border-bottom-width: 2px;
}
.border-b-4 {
	border-bottom-width: 4px;
}
.border-b-\\[0\\.5px\\] {
	border-bottom-width: 0.5px;
}
.border-l-8 {
	border-left-width: 8px;
}
.border-r-4 {
	border-right-width: 4px;
}
.border-solid {
	border-style: solid;
}
.border-bell-background {
	--tw-border-opacity: 1;
	border-color: rgb(250 249 248 / var(--tw-border-opacity, 1));
}
.border-bell-blue {
	--tw-border-opacity: 1;
	border-color: rgb(0 94 170 / var(--tw-border-opacity, 1));
}
.border-bell-green {
	--tw-border-opacity: 1;
	border-color: rgb(46 118 50 / var(--tw-border-opacity, 1));
}
.border-bell-lightgreen {
	--tw-border-opacity: 1;
	border-color: rgb(148 184 149 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
	--tw-border-opacity: 1;
	border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
	--tw-border-opacity: 1;
	border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-red-500 {
	--tw-border-opacity: 1;
	border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.bg-bell-background {
	--tw-bg-opacity: 1;
	background-color: rgb(250 249 248 / var(--tw-bg-opacity, 1));
}
.bg-bell-blue {
	--tw-bg-opacity: 1;
	background-color: rgb(0 94 170 / var(--tw-bg-opacity, 1));
}
.bg-bell-blue\\/10 {
	background-color: rgb(0 94 170 / 0.1);
}
.bg-bell-red\\/10 {
	background-color: rgb(236 32 28 / 0.1);
}
.bg-gray-50 {
	--tw-bg-opacity: 1;
	background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
	--tw-bg-opacity: 1;
	background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
	--tw-bg-opacity: 1;
	background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
	--tw-bg-opacity: 1;
	background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-violet-200 {
	--tw-bg-opacity: 1;
	background-color: rgb(221 214 254 / var(--tw-bg-opacity, 1));
}
.bg-white {
	--tw-bg-opacity: 1;
	background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.object-contain {
	object-fit: contain;
}
.object-cover {
	object-fit: cover;
}
.p-2 {
	padding: 0.5rem;
}
.p-4 {
	padding: 1rem;
}
.p-5 {
	padding: 1.25rem;
}
.px-10 {
	padding-left: 2.5rem;
	padding-right: 2.5rem;
}
.px-2 {
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}
.px-20 {
	padding-left: 5rem;
	padding-right: 5rem;
}
.px-3 {
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}
.px-4 {
	padding-left: 1rem;
	padding-right: 1rem;
}
.px-7 {
	padding-left: 1.75rem;
	padding-right: 1.75rem;
}
.py-1 {
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
}
.py-10 {
	padding-top: 2.5rem;
	padding-bottom: 2.5rem;
}
.py-2 {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
}
.py-24 {
	padding-top: 6rem;
	padding-bottom: 6rem;
}
.py-4 {
	padding-top: 1rem;
	padding-bottom: 1rem;
}
.py-5 {
	padding-top: 1.25rem;
	padding-bottom: 1.25rem;
}
.py-6 {
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
}
.py-8 {
	padding-top: 2rem;
	padding-bottom: 2rem;
}
.py-\\[5px\\] {
	padding-top: 5px;
	padding-bottom: 5px;
}
.pb-1 {
	padding-bottom: 0.25rem;
}
.pb-10 {
	padding-bottom: 2.5rem;
}
.pb-2 {
	padding-bottom: 0.5rem;
}
.pb-4 {
	padding-bottom: 1rem;
}
.pl-2 {
	padding-left: 0.5rem;
}
.pl-4 {
	padding-left: 1rem;
}
.pl-5 {
	padding-left: 1.25rem;
}
.pr-10 {
	padding-right: 2.5rem;
}
.pr-2 {
	padding-right: 0.5rem;
}
.pr-3 {
	padding-right: 0.75rem;
}
.pr-4 {
	padding-right: 1rem;
}
.pr-5 {
	padding-right: 1.25rem;
}
.pt-1 {
	padding-top: 0.25rem;
}
.pt-10 {
	padding-top: 2.5rem;
}
.pt-2 {
	padding-top: 0.5rem;
}
.pt-32 {
	padding-top: 8rem;
}
.pt-4 {
	padding-top: 1rem;
}
.pt-5 {
	padding-top: 1.25rem;
}
.text-center {
	text-align: center;
}
.text-right {
	text-align: right;
}
.font-sans {
	font-family: "Fira Sans";
}
.text-2xl {
	font-size: 1.5rem;
	line-height: 2rem;
}
.text-3xl {
	font-size: 1.875rem;
	line-height: 2.25rem;
}
.text-5xl {
	font-size: 3rem;
	line-height: 1;
}
.text-base {
	font-size: 1rem;
	line-height: 1.5rem;
}
.text-lg {
	font-size: 1.125rem;
	line-height: 1.75rem;
}
.text-sm {
	font-size: 0.875rem;
	line-height: 1.25rem;
}
.text-xl {
	font-size: 1.25rem;
	line-height: 1.75rem;
}
.text-xs {
	font-size: 0.75rem;
	line-height: 1rem;
}
.font-bold {
	font-weight: 700;
}
.font-light {
	font-weight: 300;
}
.font-medium {
	font-weight: 500;
}
.font-normal {
	font-weight: 400;
}
.font-semibold {
	font-weight: 600;
}
.font-thin {
	font-weight: 100;
}
.uppercase {
	text-transform: uppercase;
}
.capitalize {
	text-transform: capitalize;
}
.italic {
	font-style: italic;
}
.tracking-wide {
	letter-spacing: 0.025em;
}
.text-bell-blue {
	--tw-text-opacity: 1;
	color: rgb(0 94 170 / var(--tw-text-opacity, 1));
}
.text-bell-gray {
	--tw-text-opacity: 1;
	color: rgb(142 142 142 / var(--tw-text-opacity, 1));
}
.text-bell-green {
	--tw-text-opacity: 1;
	color: rgb(46 118 50 / var(--tw-text-opacity, 1));
}
.text-bell-red {
	--tw-text-opacity: 1;
	color: rgb(236 32 28 / var(--tw-text-opacity, 1));
}
.text-bell-text {
	--tw-text-opacity: 1;
	color: rgb(51 51 51 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
	--tw-text-opacity: 1;
	color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
	--tw-text-opacity: 1;
	color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
	--tw-text-opacity: 1;
	color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
	--tw-text-opacity: 1;
	color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-red-500 {
	--tw-text-opacity: 1;
	color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-stone-700 {
	--tw-text-opacity: 1;
	color: rgb(68 64 60 / var(--tw-text-opacity, 1));
}
.text-white {
	--tw-text-opacity: 1;
	color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
	text-decoration-line: underline;
}
.opacity-70 {
	opacity: 0.7;
}
.shadow {
	--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
	--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
	--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
	--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
	--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
	--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.filter {
	filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
	transition-property: all;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 150ms;
}
.duration-200 {
	transition-duration: 200ms;
}
.duration-300 {
	transition-duration: 300ms;
}
.last\\:border-0:last-child {
	border-width: 0px;
}
.focus-within\\:border-bell-blue:focus-within {
	--tw-border-opacity: 1;
	border-color: rgb(0 94 170 / var(--tw-border-opacity, 1));
}
.hover\\:-translate-y-1:hover {
	--tw-translate-y: -0.25rem;
	transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:translate-x-2:hover {
	--tw-translate-x: 0.5rem;
	transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-bell-blue:hover {
	--tw-border-opacity: 1;
	border-color: rgb(0 94 170 / var(--tw-border-opacity, 1));
}
.hover\\:bg-bell-blue:hover {
	--tw-bg-opacity: 1;
	background-color: rgb(0 94 170 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-bell-blue\\/20:hover {
	background-color: rgb(0 94 170 / 0.2);
}
.hover\\:bg-bell-red\\/20:hover {
	background-color: rgb(236 32 28 / 0.2);
}
.hover\\:bg-gray-50:hover {
	--tw-bg-opacity: 1;
	background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-opacity-40:hover {
	--tw-bg-opacity: 0.4;
}
.hover\\:text-bell-blue:hover {
	--tw-text-opacity: 1;
	color: rgb(0 94 170 / var(--tw-text-opacity, 1));
}
.hover\\:text-orange-600:hover {
	--tw-text-opacity: 1;
	color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
	text-decoration-line: underline;
}
.focus\\:underline:focus {
	text-decoration-line: underline;
}
.focus\\:outline-none:focus {
	outline: 2px solid transparent;
	outline-offset: 2px;
}
.group:hover .group-hover\\:-translate-y-1 {
	--tw-translate-y: -0.25rem;
	transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-b {
	border-bottom-width: 1px;
}
.group:hover .group-hover\\:text-bell-blue {
	--tw-text-opacity: 1;
	color: rgb(0 94 170 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-white {
	--tw-text-opacity: 1;
	color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
@media (min-width: 768px) {
	.md\\:col-span-2 {
		grid-column: span 2 / span 2;
	}
	.md\\:col-span-3 {
		grid-column: span 3 / span 3;
	}
	.md\\:col-start-3 {
		grid-column-start: 3;
	}
	.md\\:col-start-4 {
		grid-column-start: 4;
	}
	.md\\:m-10 {
		margin: 2.5rem;
	}
	.md\\:block {
		display: block;
	}
	.md\\:grid {
		display: grid;
	}
	.md\\:w-\\[300px\\] {
		width: 300px;
	}
	.md\\:grid-cols-3 {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}
	.md\\:grid-cols-4 {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
	.md\\:px-16 {
		padding-left: 4rem;
		padding-right: 4rem;
	}
}
@media (min-width: 1024px) {
	.lg\\:col-span-1 {
		grid-column: span 1 / span 1;
	}
	.lg\\:col-span-2 {
		grid-column: span 2 / span 2;
	}
	.lg\\:col-span-3 {
		grid-column: span 3 / span 3;
	}
	.lg\\:grid-cols-5 {
		grid-template-columns: repeat(5, minmax(0, 1fr));
	}
	.lg\\:px-20 {
		padding-left: 5rem;
		padding-right: 5rem;
	}
}
@media (min-width: 1280px) {
	.xl\\:col-span-2 {
		grid-column: span 2 / span 2;
	}
	.xl\\:col-span-3 {
		grid-column: span 3 / span 3;
	}
}
@media (min-width: 1536px) {
	.\\32xl\\:grid-cols-4 {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
}
@media print {
	.print\\:block {
		display: block;
	}
	.print\\:grid {
		display: grid;
	}
	.print\\:hidden {
		display: none;
	}
	.print\\:p-10 {
		padding: 2.5rem;
	}
	.print\\:shadow-none {
		--tw-shadow: 0 0 #0000;
		--tw-shadow-colored: 0 0 #0000;
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
	}
}

body {
	margin: 0;
	font-family: 'Fira Sans', Arial, Monaco, Tahoma, 'Courier New', sans-serif;
}

code {
	font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.icon:hover {
	color: #005eaa;
	cursor: pointer;
}

.icon {
	color: #8e8e8e;
}

.tableC tbody tr {
	cursor: pointer;
}

/* Centre Alignment for ANTD Icon */
svg {
	vertical-align: baseline;
}

.code-box-demo {
	overflow-x: auto;
}

.code-box-demo .ant-segmented {
	margin-bottom: 10px;
}

/* Remove spinner/dropdown from time input */
.time-input-no-spinner::-webkit-calendar-picker-indicator,
.time-input-no-spinner::-webkit-inner-spin-button,
.time-input-no-spinner::-webkit-clear-button {
    display: none;
    -webkit-appearance: none;
}

.time-input-no-spinner {
    -moz-appearance: textfield;
}

/* Optional: Remove the dropdown arrow in Firefox */
.time-input-no-spinner::-moz-calendar-picker-indicator {
    display: none;
}



`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CAAA,wBAAc;CAAd,wBAAc;CAAd,mBAAc;CAAd,mBAAc;CAAd,cAAc;CAAd,cAAc;CAAd,cAAc;CAAd,eAAc;CAAd,eAAc;CAAd,aAAc;CAAd,aAAc;CAAd,kBAAc;CAAd,sCAAc;CAAd,8BAAc;CAAd,6BAAc;CAAd,4BAAc;CAAd,eAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,kBAAc;CAAd,2BAAc;CAAd,4BAAc;CAAd,sCAAc;CAAd,kCAAc;CAAd,2BAAc;CAAd,sBAAc;CAAd,8BAAc;CAAd,YAAc;CAAd,kBAAc;CAAd,gBAAc;CAAd,iBAAc;CAAd,kBAAc;CAAd,cAAc;CAAd,gBAAc;CAAd,aAAc;CAAd,mBAAc;CAAd,qBAAc;CAAd,2BAAc;CAAd,yBAAc;CAAd,0BAAc;CAAd,2BAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,yBAAc;CAAd,sBAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,qBAAc;CAAd;AAAc;AAAd;CAAA,wBAAc;CAAd,wBAAc;CAAd,mBAAc;CAAd,mBAAc;CAAd,cAAc;CAAd,cAAc;CAAd,cAAc;CAAd,eAAc;CAAd,eAAc;CAAd,aAAc;CAAd,aAAc;CAAd,kBAAc;CAAd,sCAAc;CAAd,8BAAc;CAAd,6BAAc;CAAd,4BAAc;CAAd,eAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,kBAAc;CAAd,2BAAc;CAAd,4BAAc;CAAd,sCAAc;CAAd,kCAAc;CAAd,2BAAc;CAAd,sBAAc;CAAd,8BAAc;CAAd,YAAc;CAAd,kBAAc;CAAd,gBAAc;CAAd,iBAAc;CAAd,kBAAc;CAAd,cAAc;CAAd,gBAAc;CAAd,aAAc;CAAd,mBAAc;CAAd,qBAAc;CAAd,2BAAc;CAAd,yBAAc;CAAd,0BAAc;CAAd,2BAAc;CAAd,uBAAc;CAAd,wBAAc;CAAd,yBAAc;CAAd,sBAAc;CAAd,oBAAc;CAAd,sBAAc;CAAd,qBAAc;CAAd;AAAc;AAEd;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,gBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,gBAAmB;CAAnB,oBAAmB;CAAnB,4BAAmB;CAAnB;AAAmB;AAAnB;CAAA,gBAAmB;CAAnB,oBAAmB;CAAnB,4BAAmB;CAAnB;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB,cAAmB;CAAnB,8BAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,qDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,uDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,sDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,sDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,uDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,oDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,uDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,sDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,oDAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,+DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,8DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,8DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,4DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,4DAAmB;CAAnB;AAAmB;AAAnB;CAAA,uBAAmB;CAAnB,+DAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,gBAAmB;CAAnB,uBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,sBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,qBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB;AAAmB;AAAnB;CAAA,gBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,iBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,eAAmB;CAAnB;AAAmB;AAAnB;CAAA,eAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,mBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA,kBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA,oBAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,0EAAmB;CAAnB,8FAAmB;CAAnB;AAAmB;AAAnB;CAAA,6EAAmB;CAAnB,iGAAmB;CAAnB;AAAmB;AAAnB;CAAA,0CAAmB;CAAnB,uDAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA,wBAAmB;CAAnB,wDAAmB;CAAnB;AAAmB;AAAnB;CAAA;AAAmB;AAAnB;CAAA;AAAmB;AACnB;CAAA;AAAkB;AAAlB;CAAA,sBAAkB;CAAlB;AAAkB;AAAlB;CAAA,0BAAkB;CAAlB;AAAkB;AAAlB;CAAA,wBAAkB;CAAlB;AAAkB;AAAlB;CAAA,sBAAkB;CAAlB;AAAkB;AAAlB;CAAA,kBAAkB;CAAlB;AAAkB;AAAlB;CAAA;AAAkB;AAAlB;CAAA;AAAkB;AAAlB;CAAA,kBAAkB;CAAlB;AAAkB;AAAlB;CAAA;AAAkB;AAAlB;CAAA,oBAAkB;CAAlB;AAAkB;AAAlB;CAAA,oBAAkB;CAAlB;AAAkB;AAAlB;CAAA;AAAkB;AAAlB;CAAA;AAAkB;AAAlB;CAAA,8BAAkB;CAAlB;AAAkB;AAAlB;CAAA,0BAAkB;CAAlB;AAAkB;AAAlB;CAAA;AAAkB;AAAlB;CAAA,oBAAkB;CAAlB;AAAkB;AAAlB;CAAA,oBAAkB;CAAlB;AAAkB;AAAlB;CAAA;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA,kBAAkB;EAAlB;CAAkB;AAAA;AAAlB;CAAA;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA,kBAAkB;EAAlB;CAAkB;AAAA;AAAlB;CAAA;EAAA;CAAkB;CAAlB;EAAA;CAAkB;AAAA;AAAlB;CAAA;EAAA;CAAkB;AAAA;AAAlB;CAAA;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA;CAAkB;CAAlB;EAAA,sBAAkB;EAAlB,8BAAkB;EAAlB;CAAkB;AAAA;;AAElB;CACC,SAAS;CACT,0EAA0E;AAC3E;;AAEA;CACC,+EAA+E;AAChF;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA,mCAAmC;AACnC;CACC,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA,4CAA4C;AAC5C;;;IAGI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,mDAAmD;AACnD;IACI,aAAa;AACjB","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@tailwind variants;\n\nbody {\n\tmargin: 0;\n\tfont-family: 'Fira Sans', Arial, Monaco, Tahoma, 'Courier New', sans-serif;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.icon:hover {\n\tcolor: #005eaa;\n\tcursor: pointer;\n}\n\n.icon {\n\tcolor: #8e8e8e;\n}\n\n.tableC tbody tr {\n\tcursor: pointer;\n}\n\n/* Centre Alignment for ANTD Icon */\nsvg {\n\tvertical-align: baseline;\n}\n\n.code-box-demo {\n\toverflow-x: auto;\n}\n\n.code-box-demo .ant-segmented {\n\tmargin-bottom: 10px;\n}\n\n/* Remove spinner/dropdown from time input */\n.time-input-no-spinner::-webkit-calendar-picker-indicator,\n.time-input-no-spinner::-webkit-inner-spin-button,\n.time-input-no-spinner::-webkit-clear-button {\n    display: none;\n    -webkit-appearance: none;\n}\n\n.time-input-no-spinner {\n    -moz-appearance: textfield;\n}\n\n/* Optional: Remove the dropdown arrow in Firefox */\n.time-input-no-spinner::-moz-calendar-picker-indicator {\n    display: none;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
